<template>
  <div class="entry" v-loading="loading" element-loading-text="正进入系统中...">
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <span>
        <i
          class="el-icon-warning"
          style="color: #e6a23c; margin-right: 5px; font-size: 16px"
        ></i>
        {{ msg }}
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import BetterStorage from "@/utils-khfw/betterStorage.service.js";
import api from "@/api/wisdomSchool/index.js";
import _ from "lodash";
import {
  getPlatformSysconfig,
  getSixUser,
  getSevenUser,
  getTicket,
  schoolTeacherList,
  getChildAreaInfo,
  getQYInfo,
  getAreaInfo,
  getUserLevel,
  getManager,
  getIsManager,
  getUserInfo,
  getOrgList,
  getOrgInfo,
} from "@/api/user/userCenter.js";
import util from "@/utils/util.js";
export default {
  name: "Entry",
  data() {
    return {
      classList: [],
      orgId: "",
      dialogVisible: false,
      msg: "",
      loading: true,
    };
  },
  created() {
    this.getLineParams();
    console.log("当前环境--", process.env);
  },

  methods: {
    // 获取生产环境参数
    async getLineParams() {
      try {
        let {
          platformCode,
          loginPlatformCode,
          ticket,
          usessionId,
          orgid,
          domain,
          linktype,
          openGatewayUrl,
          uc7manageUrl,
          v_platform_code,
          children_uid,
        } = this.$route.query;
        if (!ticket) {
          let urlObj = util.getRequest();
          ticket = urlObj.ticket;
          orgid = urlObj.orgid;

          // ticket = '2f9dfc7da3e9fb19622f39634d2ec962';
          
          usessionId = urlObj.usessionId || "";
          platformCode = urlObj.platformCode || "441300";
          loginPlatformCode = urlObj.loginPlatformCode || urlObj.platformCode || '441300';
          v_platform_code = urlObj.v_platform_code || urlObj.platformCode;
          domain = urlObj.domain;
          linktype = urlObj.linktype;
          openGatewayUrl = urlObj.openGatewayUrl;
          uc7manageUrl = urlObj.uc7manageUrl;
          children_uid = urlObj.children_uid;
        }
        // console.log(
        //   "接应用中台免登-->获取url参数:",
        //   ticket,
        //   platformCode,
        //   domain,
        //   usessionId
        // );
        // 有usessionId代表从门户页进来的用户用usessionId进行登录
        if (usessionId && usessionId != "") {
          this.initUser("register", usessionId);
        }
        if (process.env.VUE_APP_MODE === "test") {
          sessionStorage.loginPlatformCode = "888880";
          sessionStorage.v_platform_code = "888880";
          sessionStorage.platformCode = "888880";
        } else {
          sessionStorage.platformCode = platformCode || "420100";
          sessionStorage.loginPlatformCode = loginPlatformCode || platformCode;
          sessionStorage.v_platform_code = v_platform_code || platformCode;
        }
        sessionStorage.ticket = ticket || "";
        sessionStorage.orgid_top = orgid || "";
        sessionStorage.linktype = linktype || "";
        sessionStorage.platformVersion = "7";
        sessionStorage.domain = domain || "https://www.wuhaneduyun.cn";
        sessionStorage.localUrl = openGatewayUrl || "";
        sessionStorage.uc7manageUrl = uc7manageUrl || "";
        sessionStorage.children_uid = children_uid || "";
        sessionStorage.needConsole = "1";
        //获取地方平台网关地址
        if (!openGatewayUrl) {
          let { result, openGatewayUrl, uc7manageUrl } =
            await getPlatformSysconfig({});
          // console.log(
          //   "获取地方平台网关地址--->",
          //   "openGatewayUrl:",
          //   openGatewayUrl,
          //   "uc7manageUrl:",
          //   uc7manageUrl
          // );
          if (result == "000000") {
            if (openGatewayUrl) {
              if (platformCode != "420100") {
                // sessionStorage.platformProject=openGatewayUrl.match(/opengate.(\S*).cn/).length>0?openGatewayUrl.match(/opengate.(\S*).cn/)[1]:'huijiaoyun'
                if (platformCode == "370000") {
                  sessionStorage.platformProject = "sdsjyy";
                } else {
                  sessionStorage.platformProject = "huijiaoyun";
                }
              }
              sessionStorage.localUrl = openGatewayUrl;
            }
            if (uc7manageUrl) {
              // 荥阳是单独部署的平台
              if (sessionStorage.platformCode == "410182") {
                sessionStorage.uc7manageUrl = "https://www.xyeduyun.cn/manage";
              } else {
                sessionStorage.uc7manageUrl = uc7manageUrl;
              }
            } else {
              sessionStorage.uc7manageUrl = openGatewayUrl;
            }
            this.initUser();
          } else {
            console.error("获取地方平台网关地址失败！");
          }
        } else {
          this.initUser();
        }
      } catch (e) {
        console.error(e);
      }
    },
    // 获取用户信息数据
    async initUser(type, usessionId) {
      try {
        let ticket;
        if (type == "register") {
          ticket = await getTicket(usessionId);
        } else {
          ticket = sessionStorage.ticket;
        }
        // let uid = "cb8204402d1411ee8d10e2f35aacef9c";
        // ticket = await getTicket(uid);
        console.log("正式环境--获取ticket:" + ticket);
        let info = {};
        if (sessionStorage.platformVersion === "6") {
          let {
            result,
            userinfo = {},
            usessionid,
          } = await getSixUser({
            ticket,
          });
          info = userinfo;
          info.usessionid = usessionid;
          info.last_user_type = userinfo.usertype;
          sessionStorage.usessionid = usessionid;
        } else {
          let { code, result = {} } = await getSevenUser({ ticket });
          result.orgId = result.last_top_org_id;
          info = result;
          info.loginPlatformCode = sessionStorage.loginPlatformCode;
          info.platformCode = sessionStorage.platformCode;
          info.personid = sessionStorage.personid;
          info.platformVersion = sessionStorage.platformVersion;
        }
        // console.log("🚀 ~ 用户信息", info);
        // 如果没有用户信息的话的就提示报错
        if (!info.user_id) {
          this.showDialog("获取用户信息失败,无法进入系统!");
          this.loading = false;
          return;
        }
        sessionStorage.personid = info?.personid || "";
        sessionStorage.usessionid = info?.usession_id || "";
        sessionStorage.orgId = info?.orgId || "";
        const betterStorage = new BetterStorage();
        betterStorage.set(
          "usessionidKeep",
          sessionStorage.usessionid,
          30 * 60 * 1000
        );
        let orgRes = await getQYInfo({
          org_id: info?.orgId || "",
          get_more: "1",
        });
        // console.log("组织信息", orgRes);
        if (orgRes.code === "000000") {
          info.province_code = orgRes.result.province_code;
          info.province_name = orgRes.result.province_name;
          info.city_code = orgRes.result.city_code;
          info.city_name = orgRes.result.city_name;
          info.area_code = orgRes.result.area_code;
          info.area_name = orgRes.result.area_name;
          info.org_level = info.org_level;
        }
        // 获取教育局省市区级别
        // let org_level_res=await getOrgLevel({"loginPlatformCode": "888888","platformCode": "888888","usessionid":"5ac2962e677811ecabdbdabd97e06828"})
        sessionStorage.userInfo = JSON.stringify(info);
        // 获取用户角色权限
        this.SaveUserRole();
        let Userlist = {
          userId: info?.user_id || "",
          platformCode: sessionStorage.platformCode,
          province_code: info?.province_code || "",
          province_name: info?.province_name || "",
          city_code: info?.city_code || "",
          city_name: info?.city_name || "",
          area_code: info?.area_code || "",
          area_name: info?.area_name || "",
        };
        // getManager({
        //   top_org_id: info.orgId,
        //   page: "1",
        //   page_size: "9999",
        //   need_count: "",
        //   app_id: "",
        //   power_id: "",
        //   dep_range: "",
        // }).then((res) => {
        //   if (res.code == "000000") {
        //     let isManager = res.result.some((it) => {
        //       return it.user_id == info.user_id;
        //     });
        //     sessionStorage.isManager = isManager;
        //   }
        // });
        // 判断用户是否学校管理员
        getIsManager({
          top_org_id: info.orgId,
          user_id: info.user_id,
          appid: "",
        }).then((res) => {
          if (res.code == "000000") {
            //  1：是，0：否
            sessionStorage.isManager = res.result;
          }
        });
        // 获取区域名称
        if (Userlist.area_code && !Userlist.area_name) {
          let area_res = await getAreaInfo({
            area_code:
              Userlist.province_code +
              "," +
              Userlist.city_code +
              "," +
              Userlist.area_code,
          });
          if (area_res.code === "000000") {
            Userlist.province_name =
              area_res.result[Userlist.province_code]?.area_name;
            Userlist.city_name = area_res.result[Userlist.city_code]?.area_name;
            Userlist.area_name = area_res.result[Userlist.area_code]?.area_name;
          }
        }
        sessionStorage.Userlist = JSON.stringify(Userlist);
        // 判断组织类型, 1:教育局, 2:学校, 8:机构
        // 判断用户类型 user_type	0:学生，1:老师，2:家长，3:工作人员，4:机构人员，5:企业人员，12:市民
        let org_type = "";
        if (info.user_top_org.length != 0) {
          info.user_top_org.forEach((it) => {
            if (it.org_id === info.last_top_org_id) {
              org_type = it.org_type;
              sessionStorage.org_type = org_type;
            }
          });
        }
        if (info.last_user_type) {
          if (sessionStorage.linktype != "otherCourseSelection") {
            if (info.last_user_type == "0" || info.last_user_type == "2") {
              this.showDialog("此用户为学生、家长角色,无法进入课后服务系统");
              return;
            }
          } else {
            // 校本选课应用限制角色为 学生
            if (info.last_user_type != "0" && info.last_user_type != "2") {
              this.showDialog("此应用只允许学生和家长进入");
              return;
            }
          }
          sessionStorage.user_type = info.last_user_type;
        } else {
          this.showDialog("此用户没有角色,无法进入课后服务系统");
          return;
        }
        if (
          info.last_user_type &&
          info.last_user_type == "2" &&
          sessionStorage.children_uid != ""
        ) {
          this.handleUserInfo();
        }
        //  获取智慧校园本地接口
        const { code, data } = await api.zhxyGatewayUrl({
          platformCode: sessionStorage.loginPlatformCode,
          vPlatformCode: sessionStorage.platformCode,
          orgId: info.orgId,
        });
        if (code == "0" && data) {
          console.log("获取智慧校园本地网关地址:", data);
          sessionStorage.zhxyGatewayUrl = data.gatewayUrl || "";
          sessionStorage.zhxyElectiveUrl = data.electiveUrl || "";
        }
        // 课程类型
        let courseType = [
          { id: "1", label: "素养课程" },
          { id: "2", label: "社团活动" },
        ];
        sessionStorage.courseType = JSON.stringify(courseType);
        // 年级
        let gradeList = [
          { id: "01", label: "一年级" },
          { id: "02", label: "二年级" },
          { id: "03", label: "三年级" },
          { id: "04", label: "四年级" },
          { id: "05", label: "五年级" },
          { id: "06", label: "六年级" },
          { id: "11", label: "初一" },
          { id: "12", label: "初二" },
          { id: "13", label: "初三" },
          { id: "21", label: "高一" },
          { id: "22", label: "高二" },
          { id: "23", label: "高三" },
        ];
        sessionStorage.gradeList = JSON.stringify(gradeList);

        // 获取学校教师列表
        let teacherList = [];
        if (org_type === "2" || org_type === "1") {
          let params = {
            top_org_id: info.last_top_org_id,
            page: 1,
            page_size: 500,
            user_type: "1",
            need_role: "1",
          };
          let teacherRes = await schoolTeacherList(params);
          if (teacherRes.code === "000000") {
            teacherList = teacherRes.result.member_list;
          }

          // 获取学期学年, 校区年级等数据
          // 获取年级信息
          if (org_type === "2") {
            // 此接口只能学校调用
            let gradeRes = await api.Teacherclass({
              org_id: sessionStorage.orgId,
            });
            console.log("获取老师班级---", gradeRes);
            if (gradeRes.code === "000000") {
              let gradeResData = gradeRes.result.list || [];
              //  org_type 部门类型(3校区，5学段，6年级，7班级)
              if (gradeResData.length > 0) {
                this.classList = [];
                let schoolList = _.groupBy(gradeResData, "org_type")["3"] || [];
                let fieldList = _.groupBy(gradeResData, "org_type")["5"] || [];
                let fieldByPid = _.groupBy(fieldList, "parent_id") || [];
                let gradeList = _.groupBy(gradeResData, "org_type")["6"] || [];
                let gradeByPid = _.groupBy(gradeList, "parent_id") || [];
                let classList = _.groupBy(gradeResData, "org_type")["7"] || [];
                let classByPid = _.groupBy(classList, "parent_id") || [];
                console.log("schoolList---", schoolList);
                if (schoolList.length > 0) {
                  schoolList.forEach((item) => {
                    let fieldChild = [];
                    if (!fieldByPid[item.org_id]) return;
                    fieldByPid[item.org_id].forEach((fieldItem) => {
                      if (!gradeByPid[fieldItem.org_id]) return;
                      gradeByPid[fieldItem.org_id].forEach((gradeItem) => {
                        let classArr = [];
                        if (!classByPid[gradeItem.org_id]) return;
                        classByPid[gradeItem.org_id].forEach((classItem) => {
                          classArr.push({
                            label: classItem.org_name,
                            id: classItem.org_id,
                            combineId: classItem.org_id,
                            children: [],
                          });
                        });
                        fieldChild.push({
                          label:
                            gradeItem.org_name.indexOf(fieldItem.org_name) != -1
                              ? gradeItem.org_name
                              : fieldItem.org_name + gradeItem.org_name,
                          id: gradeItem.org_id,
                          combineId: gradeItem.org_id,
                          children: classArr,
                        });
                      });
                    });
                    this.classList.push({
                      label: item.org_name,
                      id: item.org_id,
                      combineId: item.org_id,
                      children: fieldChild,
                    });
                  });
                  sessionStorage.classList = JSON.stringify(this.classList);
                  console.log("学校年级信息", this.classList, gradeRes);
                }
              }
            } else {
              console.log(gradeRes.message);
            }
          }
          // 获取学年学期
          let semesterRes = await api.getSemesterList({
            orgId: sessionStorage.orgId,
          });
          let semesterList = [];
          if (semesterRes.code === "0") {
            console.log("学年学期", semesterRes);
            semesterList = semesterRes.data;
          }
          // 获取课程类型
          let courseType = await api.getCourseTypeList({
            orgId: sessionStorage.orgId,
          });
          let courseTypeList = [];
          if (courseType.code === "0") {
            courseTypeList = courseType.data;
            // console.log("获取课程类型", courseTypeList);
          }
          sessionStorage.semesterList = JSON.stringify(semesterList);
          sessionStorage.courseTypeList = JSON.stringify(courseTypeList);
        }
        sessionStorage.teacherList = JSON.stringify(teacherList);

        // 教育局级别判断	省级:99  市级:1,10  区县级:2,20,4,40
        if (org_type === "1") {
          let userLevel_res = await getUserLevel({
            loginPlatformCode: sessionStorage.loginPlatformCode,
            platformCode: sessionStorage.platformCode,
            usessionid: sessionStorage.usessionid,
          });
          sessionStorage.user_level = userLevel_res.level + "";
          // 区级, 获取所有学校 小学+初中
          if (["2", "20", "4", "40"].indexOf(sessionStorage.user_level) > -1) {
            let primary_school = [],
              junior_high_school = [];
            // 小学
            let school_params_0 = {
              org_type: "2", //8	组织类型，多个使用英文逗号分隔(1机构，2学校，8企业，9教学工作室，10平台)
              org_category: "0", //	0:小学 1:初中 2:高中
              org_level_code: info.area_code, //	行政区划(行政上所属的区域)
              org_parent_id: sessionStorage.orgId || "", //	上级机构id(查的是直属下级单位)
              page: 1, //	查询页单独的对的
              page_size: 100, //	查询条数，默认10，上限100
              is_more: "1", //	返回更多信息(0:否,1:是)
              sort: "time", //按时间排序
            };
            let school_res_0 = await getOrgList(school_params_0);
            if (school_res_0.code === "000000") {
              primary_school = school_res_0.result.lists || [];
            }
            // 初中
            let school_params_1 = {
              org_type: "2",
              org_category: "1",
              org_level_code: info.area_code,
              org_parent_id: sessionStorage.orgId || "",
              page: 1,
              page_size: 100,
              is_more: "1",
              sort: "time",
            };
            let school_res_1 = await getOrgList(school_params_1);
            if (school_res_1.code === "000000") {
              junior_high_school = school_res_1.result.lists || [];
            }
            sessionStorage.primary_school = JSON.stringify(primary_school);
            sessionStorage.junior_high_school =
              JSON.stringify(junior_high_school);
          }
          if (info.last_top_org_id) {
            let org_res = await getOrgInfo({ org_id: info.last_top_org_id });
            if (org_res.code === "000000") {
              info.area_code = org_res.result.area_code || info.area_code;
              info.city_code = org_res.result.city_code || info.city_code;
              info.province_code =
                org_res.result.province_code || result.province_code;
            }
          }
          // 获取区域名称
          if (
            (info.area_code && !info.area_name) ||
            (info.city_code && !info.city_name) ||
            (info.province_code && !info.province_name)
          ) {
            let area_res = await getAreaInfo(
              info.province_code + "," + info.city_code + "," + info.area_code
            );
            if (area_res.code === "000000") {
              if (info.province_code)
                info.province_name =
                  area_res.result[result.province_code].area_name;
              if (info.city_code)
                info.city_name = area_res.result[result.city_code].area_name;
              if (info.area_code)
                info.area_name = area_res.result[result.area_code].area_name;
            }
          }
          localStorage.userInfo = JSON.stringify(info);
        }
        // 省市级
        if (
          org_type === "1" &&
          (sessionStorage.getItem("user_level") === "99" ||
            ["1", "10"].indexOf(sessionStorage.getItem("user_level")) > -1)
        ) {
          let org_code =
            sessionStorage.getItem("user_level") === "99"
              ? info.province_code
              : info.city_code;
          // 获取区域列表
          let areaList = [];
          let areaRes = await getChildAreaInfo(org_code);
          if (areaRes.code === "000000") {
            areaList = areaRes.result;
          }
          sessionStorage.areaList = JSON.stringify(areaList);
        }
        // 判断教育局类型(省市区)存入本地缓存中
        this.saveEduType();
        this.$router.push({ path: "/Home" });
      } catch (e) {
        console.error(e);
      }
    },
    showDialog(msg) {
      this.dialogVisible = true;
      this.msg = msg;
    },
    handleClose() {
      this.dialogVisible = false;
      //如果是惠州的直接退出
      console.log('打印host')
      if (window.location.host.indexOf("hzjy.edu.cn") > 0) {
          window.open('https://www.hzjy.edu.cn/index.php?r=portal/supervise/login&site=yn','_self');
          return
      } 
      if (sessionStorage.getItem("domain")) {
        window.open(
          `${sessionStorage.getItem(
            "domain"
          )}/index.php?r=portal/user/logout&service=${sessionStorage.getItem(
            "domain"
          )}/index.php?r=portal/supervise/login&site=yn`,
          "_self"
        );
      } else { 
          window.open(
            "https://www.wuhaneduyun.cn/index.php?r=portal/user/logout&service=https://www.wuhaneduyun.cn/index.php?r=portal/supervise/login&site=yn",
            "_self"
          );
        
      }
      window.sessionStorage.clear();
    },
    // 查询用户信息
    async handleUserInfo() {
      let params = {
        user_id: sessionStorage.children_uid, //机构、学校等组织id
      };
      const { code, result } = await getUserInfo(params);
      if (code == "000000") {
        sessionStorage.userInfo = JSON.stringify(result);
      }
    },
    async fetchUserInfo() {
      let params = {
        user_id: JSON.parse(sessionStorage.Userlist).userId,
      };
      let userInfo = await getUserInfo(params);
      // console.log("userInfo--", userInfo);
      sessionStorage.userInfo = JSON.stringify(userInfo);
      this.SaveUserRole();
    },
    // 获取用户角色权限
    SaveUserRole() {
      let ss = sessionStorage;
      let userInfo = JSON.parse(ss.userInfo);
      let userRole = userInfo.user_role || [];
      let userOrg = userInfo.user_org || [];
      let roleArr = []; //用户角色集合
      userRole?.forEach((item) => {
        roleArr.push(item.parent_id);
      });
      userOrg?.forEach((item) => {
        if (item.attr?.class_teacher_subject) {
          roleArr.push("1000"); //'1000'定义为普通教师
        }
      });
      // if (userInfo.subject_id) {
      // 	roleArr.push("1000"); //'1000'定义为普通教师
      // }
      // console.log("roleArr---", roleArr);
      ss.roleArr = JSON.stringify(roleArr);
      let userType = ""; //用户类型 G3管理员 G1学科组长 hTeacher班主任 teacher普通老师
      //兼任多个角色，取权限最大角色
      // let roleArr = ["226", "1000"];
      // ss.roleArr = JSON.stringify(roleArr);

      if (roleArr.includes("1") || roleArr.includes("2")) {
        return (ss.userType = "G3");
      }
      if (roleArr.includes("226")) {
        return (ss.userType = "G1");
      }
      if (roleArr.includes("202")) {
        return (ss.userType = "hTeacher");
      }
      if (roleArr.includes("1000")) {
        return (ss.userType = "teacher");
      }
    },
    saveEduType() {
      let str = "";
      if (sessionStorage.getItem("user_level") === "99") {
        str = "province";
      }
      if (["1", "10"].indexOf(sessionStorage.getItem("user_level")) > -1) {
        str = "city";
      }
      if (
        ["2", "20", "4", "40"].indexOf(sessionStorage.getItem("user_level")) >
        -1
      ) {
        str = "area";
      }
      return (sessionStorage.educationType = str);
    },
  },
};
</script>

<style lang="less" scoped>
.entry {
  display: flex;
  justify-content: center;
  margin-top: 100px;
  font-size: 20px;
  padding-top: 30%;
}
</style>
